var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalComponent',{attrs:{"name":"editar-" + _vm.codigo.id,"title":"Editar código de invitación"},on:{"close":() => _vm.close(false)}},[_c('FormEditarCodigos',{attrs:{"usos":_vm.codigo.usos},on:{"terminado":_vm.terminar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }